import { render, staticRenderFns } from "./VotingForm.vue?vue&type=template&id=9c04f836&scoped=true"
import script from "./VotingForm.vue?vue&type=script&lang=js"
export * from "./VotingForm.vue?vue&type=script&lang=js"
import style0 from "./VotingForm.vue?vue&type=style&index=0&id=9c04f836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c04f836",
  null
  
)

export default component.exports